import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ValueChangedEvent } from 'devextreme/ui/switch';
import { ChannelEmailFrequency, UserNotificationPreferenceModel } from '../../models/user-notification-preference.model';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'sp-user-settings-notification-channels',
  standalone: false,
  templateUrl: './user-settings-notification-channels.component.html',
  styleUrl: './user-settings-notification-channels.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserSettingsNotificationChannelsComponent implements OnInit, OnChanges {

  @Input() userPreferences: UserNotificationPreferenceModel;
  @Output() updatePreferences = new EventEmitter<UserNotificationPreferenceModel>();

  emailFrequency = ChannelEmailFrequency;
  formGroup: FormGroup;
  localUserPreferences: UserNotificationPreferenceModel;

  constructor(
    private fb: FormBuilder
  ) {
  }

  ngOnInit(): void {
    this.initForm();
    if (this.userPreferences) {
      this.updateFormValues();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.userPreferences?.currentValue) {
      this.localUserPreferences = changes.userPreferences.currentValue;
      this.updateFormValues();
    }
  }

  onEmailChannelSwitchChanged(e: ValueChangedEvent): void {
    if (!e.event || !this.localUserPreferences) {
      return;
    }

    const emailValue = this.formGroup.controls['emailChannelSwitch'].value;
    this.localUserPreferences.channelSetting.email = emailValue;
    this.emitPreferences();
  }

  onEmailFreqRadioChanged(frequency: ChannelEmailFrequency): void {
    if (!this.localUserPreferences) {
      return;
    }

    this.localUserPreferences.channelSetting.emailFrequencyId = frequency;
    this.emitPreferences();
  }

  private updateFormValues(): void {
    if (!this.formGroup || !this.localUserPreferences?.channelSetting) {
      return;
    }

    const controls = this.formGroup.controls;
    controls['channelEmailFrequency'].setValue(
      this.localUserPreferences.channelSetting.emailFrequencyId,
      { emitEvent: false }
    );
    controls['emailChannelSwitch'].setValue(
      this.localUserPreferences.channelSetting.email,
      { emitEvent: false }
    );
  }

  private emitPreferences(): void {
    if (this.localUserPreferences) {
      this.updatePreferences.emit(this.localUserPreferences);
    }
  }

  private initForm(): void {
    this.formGroup = this.fb.group({
      channelEmailFrequency: [''],
      emailChannelSwitch: [''],
    });
  }
}
